import ES from './es';
import EN from './en';

const paymentMovements = {
    ES,
    EN
};

export default paymentMovements;
